import PeriodType from "@/models/Shared/PeriodType";
import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import Amount from "@/models/Shared/Amount";
import ScheduleType from "@/models/Shared/ScheduleType";

export default class LendingTermSettings extends BaseProductSettings {
    enabled: boolean = false;
    termPeriodType: PeriodType = PeriodType.Year;
    termPeriodValue: number = 1;
    amount: Amount = new Amount();
    amountMinimum: Amount = new Amount();
    amountMaximum: Amount = new Amount();
    scheduleType: ScheduleType = ScheduleType.Fixed;
}